// SelectedFilters.jsx
import React from "react";

function SelectedFilters({ items, onRemove, onClearAll }) {
    if (!items.length) return null;

    return (
        <div className="ff-selected-row">
            {items.map((item) => (
                <button
                    key={item.id}
                    type="button"
                    className="ff-selected-pill"
                    onClick={() => onRemove(item)}
                >
                    {item.label}
                    <span className="ff-selected-pill__x">×</span>
                </button>
            ))}

            <button
                type="button"
                className="ff-selected-clear"
                onClick={onClearAll}
            >
                Clear All
            </button>
        </div>
    );
}

export { SelectedFilters };
